// import React, { } from "react";
// import ContactTableComponets from "./ContactTableComponets";


// function ContactTable() {

//   let header = [
//     { label: "Id", field: "id" },
//     { label: "contact Name", field: "contactname" },
//     { label: "email", field: "email" },
//     { label: "Phone number.", field: "mobileno" },
//   ];

//   return (
//     <div>
//       <ContactTableComponets
//         header={header}
//         tableTitle={"CONTACT"}
//         apiField={"CustomerContactPerson"}
//         addButton={"+ ADD"}
//         createRoute={"/contactCreate"}
//         updateRoute={"/contactView"}
//         viewRoute={"/contactView"}
//       />
//     </div>
//   );
// }

// export default ContactTable;


import React, { } from "react";
import ContactTableComponets from "./ContactTableComponets";

function CustomerTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "contact Name", field: "contactname" },
    { label: "email", field: "email" },
    { label: "Phone number.", field: "mobileno" },
  ];

  return (
    <div>
      <ContactTableComponets
        header={header}
        tableTitle={"CUSTOMER"}
        apiField={"CustomerContactPerson"}
        addButton={"+ ADD"}
        createRoute={"/contactCreate"}
        updateRoute={"/contactView"}
        viewRoute={"/contactView"}
      />
    </div>
  );
}

export default CustomerTable;